module.exports = __webpack_public_path__ + "img/visualizar.5a7985b8.svg";